import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        grow: {
            flexGrow: 1,
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
        },
        menuButton: (_a = {
                marginRight: 20
            },
            _a[theme.breakpoints.up('sm')] = {
                display: 'none',
            },
            _a),
    });
});
export function TopBar(_a) {
    var toggleDrawer = _a.toggleDrawer, userInfo = _a.userInfo, title = _a.title;
    var classes = useStyles();
    return (React.createElement(AppBar, { position: "fixed", className: classes.appBar },
        React.createElement(Toolbar, null,
            React.createElement(IconButton, { color: "inherit", "aria-label": "Open drawer", onClick: toggleDrawer, className: classes.menuButton },
                React.createElement(MenuIcon, null)),
            React.createElement(Typography, { variant: "h6", color: "inherit", className: classes.grow }, title),
            userInfo)));
}
//# sourceMappingURL=TopBar.js.map